import type { ResultHistory } from '../../../../services/MedicalResultsService';

/**
 * Strip "Hc" prefix from display for UI (e.g. "HcSteps" -> "Steps"). Health Connect only; case-sensitive.
 */
function stripHcPrefixForDisplay(value: string): string {
  if (!value || value.length <= 2) return value;
  if (value.startsWith('Hc')) return value.slice(2);
  return value;
}

function addSpacesForPascalCase(value: string): string {
  if (!value) return value;
  return value.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export type FormatLabResultDisplayForUIOptions = {
  stripHcPrefix?: boolean;
};

/**
 * Format lab result display for UI.
 * Health Connect formatting (strip `Hc`, add PascalCase spacing) is applied only when enabled.
 */
export function formatLabResultDisplayForUI(
  value: string,
  options?: FormatLabResultDisplayForUIOptions,
): string {
  if (!options?.stripHcPrefix) {
    return value;
  }

  const withoutPrefix = stripHcPrefixForDisplay(value);
  return addSpacesForPascalCase(withoutPrefix);
}

export function formatResultHistoryCodingForDisplay(
  items: ResultHistory[],
  stripHcPrefix = false,
): ResultHistory[] {
  return items.map(item => ({
    ...item,
    coding: {
      ...item.coding,
      display: formatLabResultDisplayForUI(item.coding.display, {
        stripHcPrefix,
      }),
    },
  }));
}
